module.exports = __webpack_public_path__ + "static/media/store_enriching.d50b1f8c.jpg";